<div fxLayout="column" style="margin-bottom: 16px">
    <mat-dialog-content>
        <div fxLayout="row" fxLayout.lt-sm="column">
            <div class="text">
                {{ 'serialNumberNotFound' | translate: {serialNumber: data.serialNumber} }}
            </div>
        </div>
    </mat-dialog-content>
</div>
<div mat-dialog-actions class="button-row">
    <button mat-stroked-button color="primary" (click)="close()"> {{ 'buttons.cancel' | translate }}</button>
</div>
